import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-logo" onClick={() => navigate('/')}>
              <img src={process.env.PUBLIC_URL + "/logo.png"} alt="IndustriQuote" />
            </div>
            <p className="footer-motto">
              Engineering-first parametric configurators and CPQ solutions for modern industrial manufacturing.

            </p>

          </div>

          {/* New Company Section */}
          <div className="footer-links-column">
            <h3>Company</h3>
            <ul>
              <li onClick={() => navigate('/about')}>About</li>
              <li onClick={() => navigate('/how-it-works')}>How It Works</li>

              <li onClick={() => navigate('/')}>Home</li>
            </ul>
          </div>



          {/* Contact Section */}
          <div className="footer-contact">
            <h3>Contact Us</h3>
            <p><strong>Sales:</strong> (773) 207-3269</p>
            <p><strong>General:</strong> info@IndustriQuote.com</p>

          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <span>&copy; {currentYear} IndustriQuote LLC. All rights reserved.</span>
            <div className="legal-links">
              <a href="#">Privacy Policy</a>
              <a href="#">Terms of Service</a>
              <a href="#">Security</a>
            </div>
          </div>
          <div className="footer-status">
            <span className="status-dot"></span>
            Systems Operational
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
